
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Isolation Mode","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29.75 39.87"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.64 10.06A28.79 28.79 0 0014.85 0a12.25 12.25 0 01.81 4.18 10.19 10.19 0 01-2.26 6.35 16.42 16.42 0 01-4.72 4 24.82 24.82 0 00-6 4.39A10.51 10.51 0 000 26.32a12.46 12.46 0 004.28 9.75 15.3 15.3 0 0010.56 3.81 14.25 14.25 0 0010.56-4.46 14.35 14.35 0 004.39-10.39 27.77 27.77 0 00-4.15-14.97z","fill":"#808285"}})])
          )
        }
      }
    